import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiBookOpen, FiDownload, FiShoppingBag, FiExternalLink } from 'react-icons/fi';

const books = [
  {
    icon: FiDownload,
    label: "Kindle eBook",
    price: "$5.99",
    badge: null,
    link: "https://www.amazon.com/dp/B0GHP512XW",
    cta: "Get for Kindle",
    dark: false,
  },
  {
    icon: FiShoppingBag,
    label: "Hardcover",
    price: "$20.99",
    badge: "Best Value",
    link: "https://www.amazon.com/dp/B0GVDP43BB",
    cta: "Buy on Amazon",
    dark: true,
  },
  {
    icon: FiBookOpen,
    label: "Paperback",
    price: "$13.99",
    badge: null,
    link: "https://www.amazon.com/dp/B0GVDV8DQ8",
    cta: "Buy on Amazon",
    dark: false,
  },
];

const CallToAction = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-brand-100/50 via-white to-white pointer-events-none"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-4xl md:text-5xl font-serif font-bold text-stone-900 mb-6"
        >
          Transform Your Relationship Today
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-xl text-stone-600 mb-12 max-w-2xl mx-auto"
        >
          Available now in Paperback, Hardcover, and Kindle formats on Amazon. Choose your preferred way to read and start uncovering the silent language of love.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="grid sm:grid-cols-3 gap-6 max-w-3xl mx-auto mb-12"
        >
          {books.map((book, i) => (
            <a
              key={i}
              href={book.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`p-6 rounded-2xl border-2 flex flex-col items-center group transition-all duration-300 relative no-underline
                ${book.dark
                  ? 'border-stone-900 bg-stone-900 text-white shadow-xl shadow-stone-900/10 md:-translate-y-4'
                  : 'border-stone-100 hover:border-brand-300 bg-white'
                }`}
            >
              {book.badge && (
                <div className="absolute -top-3 bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">
                  {book.badge}
                </div>
              )}

              <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-4 transition-colors
                ${book.dark ? 'bg-stone-800' : 'bg-stone-50 group-hover:bg-brand-50'}`}
              >
                <SafeIcon
                  icon={book.icon}
                  className={`w-5 h-5 ${book.dark ? 'text-white' : 'text-stone-600 group-hover:text-brand-600'}`}
                />
              </div>

              <h4 className={`font-bold mb-1 ${book.dark ? 'text-white' : 'text-stone-900'}`}>
                {book.label}
              </h4>
              <p className={`text-sm mb-4 font-semibold ${book.dark ? 'text-brand-300' : 'text-brand-600'}`}>
                {book.price}
              </p>

              <span className={`w-full py-2 text-sm font-medium rounded-lg flex items-center justify-center gap-1.5 transition-colors
                ${book.dark
                  ? 'text-stone-900 bg-white hover:bg-brand-50'
                  : 'text-brand-700 bg-brand-50 group-hover:bg-brand-600 group-hover:text-white'
                }`}
              >
                {book.cta}
                <SafeIcon icon={FiExternalLink} className="w-3.5 h-3.5" />
              </span>
            </a>
          ))}
        </motion.div>

        {/* Author page link */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.35 }}
        >
          <p className="text-stone-500 text-sm mb-3">Want to learn more before you buy?</p>
          <a
            href="https://ciomirtan.com/book/the-silent-language-of-love-8-signs-hes-more-romantic-than-you-know/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-brand-700 font-semibold hover:text-brand-900 transition-colors border-b border-brand-300 hover:border-brand-600 pb-0.5"
          >
            Visit the official book page
            <SafeIcon icon={FiExternalLink} className="w-4 h-4" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction;